import React from 'react';
import { Section, Divider } from './ui/Section';
export function Hook() {
  return <Section data-id="element-87">
      <div className="max-w-3xl mx-auto text-center" data-id="element-88">
        <h2 className="text-3xl md:text-4xl font-serif mb-8 leading-snug" data-id="element-89">
          ¿Alguna vez has abierto la cámara de tu teléfono con la intención de
          grabar un consejo valioso,{' '}
          <span className="italic text-gold-dark" data-id="element-90">
            solo para cerrarla segundos después
          </span>{' '}
          porque sientes que "este no es tu lugar"?
        </h2>

        <Divider data-id="element-91" />

        <div className="space-y-6 text-lg text-charcoal-light font-light leading-relaxed text-left" data-id="element-92">
          <p data-id="element-93">
            Mirar TikTok hoy parece una competencia de quién grita más fuerte o
            quién baila mejor. Para una mujer con tu trayectoria, ese ruido se
            siente ajeno.
          </p>
          <p data-id="element-94">
            Sientes que tienes mucho que aportar, pero te aterra la idea de
            parecer "una señora tratando de encajar" en una plataforma de
            adolescentes.
          </p>
        </div>
      </div>
    </Section>;
}